/* unplugin-vue-components disabled */import { render } from "./exhibitionItem.vue?vue&type=template&id=44baaade&scoped=true"
import script from "./exhibitionItem.vue?vue&type=script&lang=js"
export * from "./exhibitionItem.vue?vue&type=script&lang=js"

import "./exhibitionItem.vue?vue&type=style&index=0&id=44baaade&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44baaade"]])

export default __exports__